import { useId } from "react"
import { AgentType, Agent, Workspace } from "@/types"
import type { KnowledgeBaseFolder } from "@/hooks/api"
import BasicForm from "./BasicForm"
import { BasicFormType } from "./type"
import { AgentHistoryDropdownState } from "@/hooks/useAgentHistories"

interface FormFactoryProps {
  formId?: string
  agentType: AgentType
  agent?: Agent
  workspace: Workspace
  knowledgeBaseMap: Map<string, KnowledgeBaseFolder>
  agents: Agent[] // Add agents prop
  initialValues?: BasicFormType
  copilotApplyEnabled?: boolean
  flatMode?: boolean
  children?: React.ReactNode
  onConfirm?: (agentType: AgentType, formData: BasicFormType) => void
  historiesState?: AgentHistoryDropdownState
  onDirtyChange?: (dirty: boolean) => void
}

const FormFactory = ({
  formId,
  agentType,
  agent,
  workspace,
  knowledgeBaseMap,
  agents,
  initialValues,
  copilotApplyEnabled,
  flatMode: _flatMode = false,
  children,
  onConfirm,
  historiesState,
  onDirtyChange,
}: FormFactoryProps) => {
  const defaultFormId = useId()
  const actualFormId = formId || defaultFormId

  return (
    <>
      {agentType === AgentType.Basic && (
        <BasicForm
          formId={actualFormId}
          currentAgent={agent}
          workspace={workspace}
          knowledgeBaseMap={knowledgeBaseMap}
          agents={agents}
          initialValues={initialValues}
          copilotApplyEnabled={copilotApplyEnabled}
          onConfirm={(formData: BasicFormType) =>
            onConfirm?.(AgentType.Basic, formData)
          }
          historiesState={historiesState}
          onDirtyChange={onDirtyChange}
        >
          {children}
        </BasicForm>
      )}
    </>
  )
}

export default FormFactory
